<template>
  <v-card class="w-100 mb-6" @click="redirectToIssuePage(issue.key)">
    <v-card-text class="d-flex flex-column gap-2">
      <h6 data-testid="issue-key" class="font-weight-bold">{{ issue.key }}</h6>
      <SoStatus
        data-testid="issue-status"
        :status="
          new Status(
            mapColorNameToStatus(issue.fields.status.statusCategory.colorName),
            issue.fields.status.name,
          )
        "
      />
      <p data-testid="issue-summary" class="summary">
        {{ issue.fields.summary }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IJiraIssue } from "@/models/jiraIssue/jiraIssue.types"
  import { SoChipType } from "@/types/components/SoChip"
  import SoStatus from "@/components/SoStatus.vue"
  import { mapColorNameToStatus, Status } from "@/types/Status"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: { SoStatus },
    props: {
      issue: {
        type: Object as PropType<IJiraIssue>,
        required: true,
      },
    },
    computed: {
      Status() {
        return Status
      },
      SoChipType() {
        return SoChipType
      },
    },
    methods: {
      mapColorNameToStatus,
      redirectToIssuePage(issueId: string) {
        this.$router.push({
          name: RouteNames.CustomerOperationsIssues,
          params: { issueId },
        })
      },
    },
  })
</script>

<style scoped>
  .summary {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .v-card:hover {
    background-color: rgb(var(--v-theme-normal));
  }
</style>
